import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Router } from "@angular/router";
import { SessionTimeoutService } from "../../services";

@Injectable()
export class AdminPortalAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private sessionTimeoutService: SessionTimeoutService
  ) {}

  canActivate() {
    if (sessionStorage.getItem("User")) {
      sessionStorage.setItem("LastActiveTimestamp", new Date().toISOString());
      this.sessionTimeoutService.refreshTimer();
      return true;
    }

    this.router.navigate(["/login/admin"]);
    return false;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/guard/admin-portal/admin-portal-auth.guard.ts